import { PayrollActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { PayrollFormData } from 'src/screens/General/screens/Payrolls/components/PayrollForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { GetAdminWorksAction } from './adminWork-actions';

export interface UpdatePayrollAction {
    type: typeof PayrollActions.UPDATE_PAYROLL;
    payload: {
        data: Partial<PayrollFormData>;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function updatePayroll(
    data: Partial<PayrollFormData>,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): UpdatePayrollAction {
    return {
        type: PayrollActions.UPDATE_PAYROLL,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}

export interface GetPayrollsAction {
    type: typeof PayrollActions.FETCH_PAYROLLS;
    payload: QueryParams;
}

export function getPayrolls(params: QueryParams): GetPayrollsAction {
    return {
        type: PayrollActions.FETCH_PAYROLLS,
        payload: params,
    };
}
export function getPayrollsCsv(params: QueryParams): GetAdminWorksAction {
    return {
        type: PayrollActions.FETCH_PAYROLLS_CSV,
        payload: params,
    };
}

export function getPayrollsInFile(params: QueryParams): GetPayrollsAction {
    return {
        type: PayrollActions.FETCH_PAYROLLS_IN_FILE,
        payload: params,
    };
}

export interface GetPayrollsEntitiesAction {
    type: typeof PayrollActions.FETCH_PAYROLLS_ENTITIES;
    payload: { id: string | number; caseEnt: string };
}

export function getPayrollsEntities(params: { id: string | number; caseEnt: string }): GetPayrollsEntitiesAction {
    return {
        type: PayrollActions.FETCH_PAYROLLS_ENTITIES,
        payload: params,
    };
}

export interface GetProvidersPayrollsAction {
    type: typeof PayrollActions.FETCH_PAYROLLS_PROVIDERS;
    payload: { dateFrom: string; dateTo: string };
}

export function getProvidersPayroll(payload: { dateFrom: string; dateTo: string }): GetProvidersPayrollsAction {
    return {
        type: PayrollActions.FETCH_PAYROLLS_PROVIDERS,
        payload,
    };
}
export interface GetPayrollAction {
    type: typeof PayrollActions.FETCH_PAYROLL;
    payload: {
        id: string | number;
    };
}

export function getPayroll(id: string | number): GetPayrollAction {
    return {
        type: PayrollActions.FETCH_PAYROLL,
        payload: { id },
    };
}

export interface DeletePayrollAction {
    type: typeof PayrollActions.DELETE_PAYROLL;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deletePayroll(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeletePayrollAction {
    return {
        type: PayrollActions.DELETE_PAYROLL,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistPayrollAction {
    type: typeof PayrollActions.PERSIST_PAYROLL;
    payload: {
        data: PayrollFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistPayroll(data: PayrollFormData, callbacks: SagaPromise<any>): PersistPayrollAction {
    return {
        type: PayrollActions.PERSIST_PAYROLL,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistPayroll = (data: PayrollFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistPayroll(data, { resolve, reject }));
    });
};

export type Actions =
    | GetPayrollsAction
    | GetPayrollAction
    | DeletePayrollAction
    | PersistPayrollAction
    | GetProvidersPayrollsAction
    | UpdatePayrollAction
    | GetPayrollsEntitiesAction;
